import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../.services/settings.service';
import { ConnectionService } from '../../.services/connection.service';

declare var DetectRTC;

@Component({
  selector: 'app-create-join-menu',
  templateUrl: './create-join-menu.component.html',
  styleUrls: ['./create-join-menu.component.css']
})
export class CreateJoinMenuComponent implements OnInit {


  startFormOpen: boolean;  
  settings: SettingsService;
  connection: ConnectionService;
  username: string;
  roomId: string;
  audio: boolean;
  video: boolean;
  screen: boolean;
  private: boolean;
  password: string;
  formComplete: boolean;
  formMode: string;
  errors: Array<string>;
  

  

  clearErrors = () => {
    
  }
  
  addError = () => {

  }



  toggleVideoContraint = () => {
    this.settings.toggleVideoContraint();
  }

  toggleAudioContraint = () => {
    this.settings.toggleAudioContraint();
  }

 start = (e) => {
    if(e.keyCode == 13) {
      this.submit();
    }
 }
 
 hideMenu = () => {
   document.getElementById('startForm').classList.add('hide');
 }

 showMenu = () => {
   document.getElementById('startForm').classList.remove('hide');
 }

 changeFormMode = (event) => {
    if(event.target.innerText == "Create") {
      this.formMode = 'create';
    } else {
      this.formMode = 'join';
    }
    console.log(this.formMode)
 }

 checkForm = () => {
   console.log('check form')
   //check this.username to make sure matches length and other params
    if(this.formMode == 'create') {
      //check document.getElementById('createRoomName') to make sure matches length and other params
      //check password is entered if private set tot rue 
      
      return true
    } else {
      //check document.getElementById('JoinRoomName') to make sure matches length and other params  
      //check password if private is set to true

      return true
    }
 }

  updateUsername = () => {
    this.settings.setUsername(this.username);
  }

  checkIsHost = () => {
    setTimeout(()=>{
      if(this.connection.connection.isInitiator) {
        this.connection.setHost();
      }
    }, 3000)
  }

  checkRoomExists = () => {
    return new Promise((resolve, reject) => {
        let r = this.roomId;
        this.connection.connection.checkPresence(this.roomId, (isRoomExist, r) => {
          if(isRoomExist === false) {
            console.log('ROOM DOES NOT EXIST')
            resolve(false);
          } else {
            console.log('ROOM DOES EXIST')
            resolve(true);
          }
        })
      }).catch(err => {
        console.log(err)
      })
  }

  checkAudioOnly = () => {
    if(this.audio && !this.video) {
      this.settings.setAudioOnly(true);
    }
  }

  createRoom = () => {
    if(this.checkForm()) {
      this.checkRoomExists()
        .then((exists) =>{
          if(exists) {
            console.log('THAT ROOM ALREADY EXITS'); //put error in error log
          } else {
            this.updateUsername();
            this.settings.changeStartForm(false);
            this.connection.connection.open(this.roomId);
            this.checkAudioOnly();
            this.checkIsHost()
          }
        })
    }
  }

  createRoomWithPassword = () => {
    if(this.checkForm()) {
      this.checkRoomExists()
        .then((exists) => {
          if(exists) {
            console.log('That room already exists')
          } else {
            this.updateUsername();
            this.settings.changeStartForm(false);
            this.connection.connection.openOrJoin(this.roomId, this.password);
            this.checkIsHost();           
          }
        });
    }
  }

  joinRoom = () => {
      if(this.checkForm()){
       this.checkRoomExists()
        .then((exists) =>{
          if(exists) {
            this.updateUsername();
            this.settings.changeStartForm(false);
            this.connection.join(this.roomId);
            this.checkIsHost();
          } else {
            console.log('That Room DoesnT Exist')
          }
       })
      }
  }

  joinWithPassword = () => {
     if(this.checkForm()){
        this.checkRoomExists()
          .then((exists) => {
            if(exists) {
              this.updateUsername();
              this.settings.changeStartForm(false);
              this.connection.connection.openOrJoin(this.roomId, this.password); //use check function to stop if private is true and password is empty MIGHT break announcename propagation - if so change to this.connection.join() or create new function wichin includes createOrJoin with announcename propagation
              this.checkIsHost();
            } else {
              console.log('room doesnt exist')
            }
          });
     }
  }

  checkAudioVideoDontExist = () => {
    if(DetectRTC.videoInputDevices.length < 1 && DetectRTC.videoInputDevices.length < 1) {
      return(true);
    }
  }

  checkRoomNameEntered = () => {
    if(this.roomId == "" || this.roomId == undefined){
      console.log('you need a room id')
      //add error
      return(false);
    }
    return(true)
  }

  submit = () =>{
    if(this.checkAudioVideoDontExist()) {
      console.log('required audio or video device')
      //add errors
      return
    }

    if(this.formMode == 'create') {
      if(!this.checkRoomNameEntered()){
        return
      }
      if(this.password == undefined || this.password == ""){ 
        this.createRoom();
      } else {
        this.createRoomWithPassword();
      }
    } else {
      if(this.private) {
        this.joinWithPassword()
      } else {
        this.joinRoom();
      }
    }
  }

  checkAudioDevices = () => {
    if(DetectRTC.audioInputDevices.length > 0) {
      return(true);
    }
  }

  checkVideoDevices = () => {
    if(DetectRTC.videoInputDevices.length > 0) {
      return(true);
    }
  }

  

  constructor(private settingsService: SettingsService, private connectionService: ConnectionService) { 
    this.settings = settingsService;
    this.connection = connectionService;

    this.connection.connection.onInvalidPassword = function(remoteUserId, oldPassword) {
        //add error to error array (local storage)
        //store roomname in local storage
        //reload page
    };

    this.connection.connection.onPasswordMaxTriesOver = function(remoteUserId) {
      alert(remoteUserId + ' is password protected. Your max password tries exceeded the limit.');
    };


  }


  ngOnInit() {
    this.username = this.settings.username;
    this.formComplete = false;
    this.formMode = 'join';
    this.private = false;

 
    this.settings.startFormOpenCast.subscribe(state => {
      this.startFormOpen = state;
      if(this.startFormOpen) {
        this.showMenu()
      } else {
        this.hideMenu();
      }
    });

    this.settings.connectionConstraintsCast.audioCast.subscribe(audioSetting => {   
      this.audio = audioSetting;
    });

    this.settings.connectionConstraintsCast.videoCast.subscribe(videoSetting => {
      this.video = videoSetting;
    });

    this.settings.connectionConstraintsCast.screenCast.subscribe(screenSetting => {
      this.screen = screenSetting;
    });

    DetectRTC.load(()=>{
      if(!this.checkAudioDevices()){
        this.settings.toggleAudioContraint();
        let fakesfa = document.getElementById('fakesfa');
        let fsa = document.getElementById('sfa').classList.add('hide');
            fakesfa.classList.remove('hide')
            //hide switch, unhide placeholder
      }

      if(!this.checkVideoDevices()){
        this.settings.toggleVideoContraint();
        let fakevfa = document.getElementById('fakevfa');
        let vfa = document.getElementById('vfa').classList.add('hide');
            fakevfa.classList.remove('hide')
        
            //hide switch, unhide placeholder
      }
    });
   
  }

}
